import { d as debounce } from './debounce-CFN_LA0O.js';
import { C as Cart } from './cart-D33A22VA.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';
import './uniq-BDEfcc0N.js';

class CartItem extends HTMLElement {
  #unsubscriber;
  #lineItemIndex = this.dataset.lineItemIndex;
  #loadingOverlay = this.querySelector('.loading-overlay');

  connectedCallback() {
    this.#unsubscriber = PubSub.subscribe('quantity:change', ({ line, quantity }) =>
      this.#handleQuantityChange(line, quantity)
    );
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * @description Handle the quantity change event
   * @param {number} line - The line item index
   * @param {number} quantity - The quantity
   */
  #handleQuantityChange = debounce(async (line, quantity) => {
    if (line !== this.#lineItemIndex) return;

    this.#handleLoading(true);

    try {
      await Cart.change({
        line: this.#lineItemIndex,
        quantity,
      });
    } catch (error) {
      Notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }, 300);

  /**
   * @description Handle the loading overlay
   * @param {boolean} loading - The loading state
   */
  #handleLoading(loading) {
    this.#loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('line-item', CartItem);
